module.exports = __webpack_public_path__ + "static/img/authentication1.33a75b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/authentication1.png
// module id = zhut
// module chunks = 1